const faqData = [
    {
        id: 1,
        pertanyaan: "Apa itu Raja Brawijaya?",
        jawaban:
            "RAJA Brawijaya atau Rangkaian Acara Jelajah Almamater Universitas Brawijaya adalah serangkaian kegiatan yang bertujuan memfasilitasi dan Mahasiswa Baru Universitas Brawijaya untuk mengetahui hal-hal terkait dengan kehidupan kampus.",
    },
    {
        id: 2,
        pertanyaan: "Kapan RAJA Brawijaya dilaksanakan?",
        jawaban:
            "Dilaksanakan pada 17-19 agustus 2021, dimana tanggal 17 adalah Opening Ceremony dan tanggal 18 - 19 adalah PKKMB RAJA Brawijaya",
    },
    {
        id: 3,
        pertanyaan: "Apakah hukum mengikuti RAJA Brawijaya?",
        jawaban:
            "Wajib hukumnya bagi mahasiswa baru untuk mengikuti Acara RAJA Brawijaya.",
    },
    {
        id: 4,
        pertanyaan: "Apakah boleh terlambat datang pada RAJA Brawijaya?",
        jawaban: "Kalian sudah tau jawabannya apa",
    },
    {
        id: 5,
        pertanyaan: "Apa saja akun sosial media resmi RAJA Brawijaya?",
        jawaban:
            "Kunjungi bagian bawah website, lalu klik icon sosial media yang tersedia.",
    },
    {
        id: 6,
        pertanyaan:
            "Apakah RAJA Brawijaya menyediakan grup untuk para mahasiswa baru?",
        jawaban:
            "Raja Brawijaya HANYA menyediakan grup maba yang tertera di bagian dashboard RAJA Apps.",
    },
    {
        id: 7,
        pertanyaan: "Bagaimana pembagian cluster RAJA Brawijaya?",
        jawaban:
            "Cluster dibagi menjadi 64 Cluster dan dapat dilihat di Kartu Tanda Mahasiswa Sementara (KTMS) pada Sistem Informasi Akademik Mahasiswa (SIAM) di pojok kanan atas.",
    },
    {
        id: 8,
        pertanyaan: "Apa itu cluster?",
        jawaban:
            "Orang yang membantu kerja para dokter di rumah sakit. Iya, barusan adalah definisi yang salah. Lalu apa yang benar kak?. Uh, santai jangan terburu-buru, cluster adalah sistem pembagian Mahasiswa Baru dalam bentuk kelompok.",
    },
    {
        id: 9,
        pertanyaan:
            "Mengapa status cluster di form registrasi masih kosong atau (-)?",
        jawaban:
            "Itu artinya kamu belum melakukan pembayaran UKT. Kejamkan? iya, begitulah kehidupan kamu harus membayar untuk bisa mendapatkan teman.",
    },
    {
        id: 10,
        pertanyaan:
            "Kenapa status cluster di form registrasi masih (-) padahal sudah membayar UKT?",
        jawaban:
            "Uh, santai jangan terburu-buru. Status akan berubah dalam rentang waktu 3 hari setelah pembayaran UKT",
    },
    {
        id: 11,
        pertanyaan: "Apakah cluster dapat berubah?",
        jawaban:
            "Sayangnya tidak bisa. Kamu tidak bisa merequest dengan siapa kamu ingin satu cluster. Nikmati masa-masa SKSD kamu bersama temanmu yang lain, mana tau ya kan ada yang nyangkut. hahaha",
    },
    {
        id: 12,
        pertanyaan: "Apa itu PKKMB?",
        jawaban:
            "Pengenalan Kehidupan Kampus Mahasiswa Baru Universitas Brawijaya (PKKMB) adalah kegiatan penyambutan mahasiswa baru sebagai bentuk kegiatan yang bertujuan untuk membuat rasa kebanggan dan penanaman nilai kepada mahasiswa baru akan almamater kita bersama, Universitas Brawijaya.",
    },
    {
        id: 13,
        pertanyaan: "Kapan PKKMB dilaksanakan?",
        jawaban: "PKKMB dilaksanakan pada 18-19 Agustus 2021",
    },
    {
        id: 14,
        pertanyaan: "Apa itu PBPK?",
        jawaban:
            "PBPK atau Pembinaan Budi Pekerti dan Kepimpinan yang merupakan rangkaian acara yang bertujuan melakukan pembinaan karakter keagamaan, melatih jiwa kepemimpinan dan mengajarkan kita untuk dapat membela Negara Kesatuan Republik Indonesia (NKRI) bagi Mahasiswa Baru Universitas Brawijaya.",
    },
    {
        id: 15,
        pertanyaan: "Apa yang dilakukan ketika PBPK?",
        jawaban:
            "Pembinaan Budi Pekerti dan Kepemimpinan (PBPK) merupakan rangkaian acara yang bertujuan untuk melakukan pembinaan karakter keagamaan, melatih jiwa kepemimpinan dan mengajarkan kita untuk dapat membela Negara Kesatuan Republik Indonesia (NKRI) dan mahasiswa baru Universitas Brawijaya.",
    },
    {
        id: 16,
        pertanyaan: "Apa itu OH?",
        jawaban:
            "OH OKM atau Open House Lembaga Kedaulatan Mahasiswa yang mana merupakan penutup dari serangkaian acara RAJA Brawijaya. Di sana kamu bisa memilih Unit Kegiatan Mahasiswa (UKM) dan OKM di Universitas Brawijaya sesuai dengan minat dan bakat di bidang akademik maupun non-akademik.",
    },
    {
        id: 17,
        pertanyaan: "Apa yang dilakukan ketika OH?",
        jawaban:
            "OH OKM atau Open House Lembaga Kedaulatan Mahasiswa yang mana merupakan penutup dari serangkaian acara RAJA Brawijaya. Di sana kamu bisa memilih Unit Kegiatan Mahasiswa (UKM) dan OKM di Universitas Brawijaya sesuai dengan minat dan bakat di bidang akademik maupun non-akademik.",
    },
    {
        id: 18,
        pertanyaan:
            "Bagaimana ketentuan pakaian dan rambut ketika rangkaian RAJA Brawijaya?",
        jawaban:
            'Ketentuan pakaian selama rangkain acara dapat dilihat pada "Informasi Atribut" menu Abhiyaksa Info di Website RAJA Brawijaya.',
    },
    {
        id: 19,
        pertanyaan:
            "Apakah selama rangkaian RAJA Brawijaya terdapat penugasan?",
        jawaban: "Penugasan dapat dilihat pada menu “Penugasan” di RAJA Apps.",
    },
    {
        id: 20,
        pertanyaan: "Bagaimana caranya login di website RAJA Apps?",
        jawaban: "Tutorial login dapat kamu lihat di IG TV RAJA brawijaya",
    },
    {
        id: 21,
        pertanyaan: "Apa itu RAJA Apps?",
        jawaban:
            "RAJA Apps merupakan platform yang digunakan MABA selama rangkaian RAJA Brawijaya untuk memberikan informasi terkait rangkaian acara, penugasan, dan minat UKM.",
    },
    {
        id: 23,
        pertanyaan: "Apa perbedaan nomor pendaftaran dengan NIM?",
        jawaban:
            "Nomor pendaftaran merupakan nomor peserta SNMPTN/SBMPTN/Mandiri sedangkan, NIM (Nomor Induk Mahasiswa) sebagai identitas mahasiswa.",
    },
    {
        id: 24,
        pertanyaan: "Bagaimana pembagian jas almamater UB?",
        jawaban:
            "Informasi jas almamater akan diinfokan dikemudian hari. Kemudian hari yang tidak pasti kapan datangnya.",
    },
    {
        id: 25,
        pertanyaan:
            'Apakah bagian "isi” diperbolehkan untuk menggunakan bahasa daerah?.',
        jawaban:
            "Untuk bagian “isi” diutamakan menggunakan bahasa Indonesia, tetapi penggunaan bahasa daerah juga diperbolehkan",
    },
    {
        id: 26,
        pertanyaan:
            "Bahasa daerah yang digunakan sesuai domisili masing-masing atau asal daerah/kampung halaman",
        jawaban: "keduanya diperbolehkan",
    },
    {
        id: 27,
        pertanyaan: "Dimana pembagian sub topik dapat dilihat?",
        jawaban:
            "Subtopik yang dibahas pada penugasan video dapat dilihat di website RAJA Brawijaya 2021 pada bagian penugasan video “Gaung Budaya Nusantara",
    },
    {
        id: 28,
        pertanyaan:
            "Apakah subtitle bahasa Indonesia wajib diberikan di keseluruhan video?",
        jawaban:
            "Subtitle bahasa Indonesia wajib disertakan di keseluruhan video, bukan hanya di bagian yang menggunakan bahasa daerah saja.",
    },
    {
        id: 29,
        pertanyaan:
            "Apakah pada bagian “isi” boleh menyertakan video atau gambar dari sumber lain (contoh: Youtube) untuk mendukung penjelasan video?",
        jawaban: "Diperbolehkan",
    },
    {
        id: 30,
        pertanyaan:
            "Apakah penugasan tidak boleh dihapus/diarsip/private Instagram sebelum periode yang ditentukan?",
        jawaban:
            "Tidak boleh, karena akan berpengaruh pada kemunculan nilai penugasan.",
    },
    {
        id: 31,
        pertanyaan:
            "Untuk jargon Kita Satu Brawijaya diucapkan perwakilan kelompok, masing-masing mahasiswa baru, atau bersama satu kelompok?",
        jawaban: "Diucapkan bersama satu kelompok dalam satu frame.",
    },
    {
        id: 32,
        pertanyaan: "Bagaimana definisi untuk batik bebas sopan?",
        jawaban: "Batik yang tidak ketat dan menutupi dada.",
    },
    {
        id: 33,
        pertanyaan:
            "Apa konsekuensi jika mahasiswa baru menghapus/mengarsip penugasan dan melakukan private akun Instagram sebelum tanggal 17 Desember 2021?",
        jawaban: "Penugasan tidak dapat dikoreksi.",
    },
    {
        id: 34,
        pertanyaan:
            "Apa konsekuensi jika caption penugasan tidak sesuai ketentuan?",
        jawaban: "Penugasan tidak dapat dikoreksi.",
    },
    {
        id: 35,
        pertanyaan:
            "Apa konsekuensi jika video penugasan tidak sesuai dengan durasi yang ditetapkan?",
        jawaban: "Konsekuensinya adalah akan mempengaruhi penilaian.",
    },
    {
        id: 36,
        pertanyaan:
            "Apakah diperbolehkan apabila ukuran poster berbeda dengan ketentuan?",
        jawaban:
            "Tidak diperbolehkan karena ukuran poster sudah disesuaikan dengan template.",
    },
    {
        id: 37,
        pertanyaan:
            "Ukuran poster yang berupa berukuran 4:5 atau 1080 x 1350 pixel untuk sebelum atau sesudah dimasukkan ke template?",
        jawaban:
            "Ukuran poster berukuran 4:5 atau 1080 x 1350 pixel adalah ukuran sebelum dimasukkan ke template.",
    },
    {
        id: 38,
        pertanyaan: "Bagaimana definisi untuk baju bebas sopan?",
        jawaban: "Baju yang tidak ketat, tidak transparan, dan menutupi dada.",
    },
    {
        id: 39,
        pertanyaan: "Apakah penulisan essay sumber harus dari jurnal?",
        jawaban:
            "Harus, karena website RAJA Brawijaya hanya bisa menerima link dari jurnal bukan Wikipedia/blogspot.",
    },
    {
        id: 40,
        pertanyaan: "Apakah infografis diperbolehkan mencantumkan gambar?",
        jawaban:
            "Boleh, karena isi infografis tidak hanya sekedar tulisan diperbolehkan dengan menambahkan gambar.",
    },
    {
        id: 41,
        pertanyaan:
            "Apakah infografis diperbolehkan dibuat dengan tulisan tangan (manual)?",
        jawaban:
            "Tidak boleh, karena pembuatan infografis harus dengan aplikasi editing.",
    },
    {
        id: 42,
        pertanyaan:
            "Apakah terdapat ketentuan jumlah kalimat pada caption infografis?",
        jawaban:
            "Tidak ada, karena caption dibuat dengan penjelasan yang jelas dan singkat.",
    },
    {
        id: 43,
        pertanyaan:
            "Apakah pengerjaan soal bisa dilompat ke pertanyaan selanjutnya?",
        jawaban: "pengerjaan soal harus urut sesuai soal yang sudah muncul",
    },
    {
        id: 44,
        pertanyaan:
            "Dimana mendapatkan informasi untuk menjawab pertanyaan soal?",
        jawaban:
            "Untuk menjawab pertanyaan bisa mencari dari website universitas brawijaya, official account instagram RAJA Brawijaya, official account instagram EM brawijaya, dan website buku panduan PKM universitas brawijaya.",
    },
    {
        id: 45,
        pertanyaan:
            "Apakah mahasiswa tetap bisa mengerjakan jika tidak sesuai dengan jadwal yang ditentukan?",
        jawaban:
            "penugasan dikerjakan sesuai dengan waktu yang sudah ditentukan pada setiap cluster. Jika tidak sesuai dengan itu, maka dianggap tidak mengerjakan penugasan.",
    },
    {
        id: 46,
        pertanyaan:
            "Bagaimana jika pengerjaan lebih dari waktu yang sudah diberikan?",
        jawaban:
            "Maksimalkan waktu yang sudah diberikan. Jika pengerjaan lebih dari waktu yang ditentukan, maka akan ada pengurangan nilai.",
    },
    {
        id: 47,
        pertanyaan: "Bagaimana jika terjadi kendala dalam pengerjaan soal?",
        jawaban:
            "jika terjadi kendala dalam pengerjaan, maka bisa segera untuk menghubungi lini masa atau melihat FAQ kendala untuk informasi lebih lanjut.",
    },
    {
        id: 48,
        pertanyaan:
            "Bagaimana jika ketika dalam mengerjakan tidak sengaja keluar dari homepage?",
        jawaban:
            "jika ketika mengerjakan keluar dari homepage, maka pertanyaan akan diulang lagi dari awal.",
    },
    {
        id: 49,
        pertanyaan: "Dimana buku pedoman PKM dapat diakses?",
        jawaban:
            "Buku pedoman PKM dapat dicari di google atau bisa melalui website PKM Universitas Brawijaya",
    },

    {
        id: 51,
        pertanyaan:
            "Dimana link sumber untuk mengakses video bumper RAJA Brawijaya 2021?",
        jawaban:
            "Bumper RAJA Brawijaya 2021 dapat diakses dalam link berikut https://bit.ly/PerangkatPenugasanAbhiyaksa59",
    },

    {
        id: 50,
        pertanyaan:
            "Apakah MABA diwajibkan memposting twibbon yang telah diberikan?",
        jawaban:
            "Wajib ya sobat, niatkan dalam hati kalian posting twibbon bukan untuk pamer, tetapi untuk menanamkan kebanggaan kalian sudah berhasil keterima di UB, asik.",
    },
    {
        id: 52,
        pertanyaan: "Nama pada nametag ditulis tangan atau ketik?",
        jawaban: "Bebas asal sopan",
    },
    {
        id: 53,
        pertanyaan:
            "Bagaimana jika pantofel saya ada aksesorisnya tapi tetap warna dominannya hitam?",
        jawaban:
            "Asalkan berwarna hitam, dan bukan warna merah pdip atau ungu maghrib.",
    },
    {
        id: 54,
        pertanyaan:
            "Kemeja saya berwarna putih, tetapi ada kantongnya. Apakah boleh?",
        jawaban:
            "Poin utamanya adalah berwarna putih dan merupakan kemeja, silahkan tarik kesimpulan dari pernyataan itu.",
    },
    {
        id: 55,
        pertanyaan: "Ketentuan untuk foto nametag?",
        jawaban:
            "Foto formal background merah dengan kemeja putih, kerudung putih (bagi perempuan yang berhijab dan tidak berhijab memakai dasi hitam), memakai dasi hitam untuk laki-laki, disarankan menggunakan foto SIAM.",
    },
    {
        id: 56,
        pertanyaan: "Kalau foto SIAM menggunakan almet UB boleh?",
        jawaban: "Boleeeeh sobat boleh.",
    },
    {
        id: 57,
        pertanyaan:
            "Saya punya nya rok span/plisket tapi berwarna hitam, boleh?",
        jawaban:
            "Rok wiru. Diketentuan sudah dijelaskan jangan bernegosiasi, ok.",
    },
    {
        id: 58,
        pertanyaan:
            "Apakah sabuk harus hitam polos? bagaimana jika sabuk SMA/SMK?",
        jawaban: "Hitam, jika ada logo SMA/SMK tidak apa-apa.",
    },
    {
        id: 59,
        pertanyaan: "Pantofel wajib ada talinya?",
        jawaban:
            "Diketentuan sudah jelas ya sob, pantofel hitam titik. Berarti selama itu hitam dan pantofel diperbolehkan.",
    },
    {
        id: 60,
        pertanyaan:
            "Nametag fotonya boleh langsung print atau tempel pake lem?",
        jawaban:
            "Boleh yang mana aja yaaaaaaa, selama itu foto anda bukan tetangga anda.",
    },
    {
        id: 61,
        pertanyaan: "Saya PSDKU Kediri, dicaption fakultasnya jadi apa ya?",
        jawaban: "PSDKU Kediri.",
    },
    {
        id: 62,
        pertanyaan: "Apakah foto siam bisa diganti?",
        jawaban: "Bisa, info lebih lanjut hubungi Halo Selma",
    },
    {
        id: 63,
        pertanyaan:
            "Ketika rangkaian saya ada jadwal vaksin, apakah boleh izin?",
        jawaban:
            "yah, sayangnya tidak. karena PKKMB hanya dilakukan hanya 1 dalam masa perkuliahan, sedangkan jadwal vaksin bisa di reschedule. Bisa gasih sekaliii aja prioritasin aku (PKKMB) abis itu kamu bebas mau ngapain terserah.",
    },
    {
        id: 64,
        pertanyaan: "Tempat untuk melakukan perizinan dimana ya?",
        jawaban:
            "Perizinan bisa dilakukan di RAJA Apps. tapi ingat, baca dulu syarat perizinannya!! okay? dibaca yaaa... ",
    },
    {
        id: 65,
        pertanyaan: "Pendataan Media Sosial di RAJA Apps untuk apa?",
        jawaban:
            "Pendataan itu digunakan biar temen 1 kelompok kamu nantinya bisa menghubungi kamu perihal penugasan Kelompok. temen 1 kelompokmu juga manusia, bukan cenayang jadi isi datanya dengan benar yaaaa....",
    },
    {
        id: 66,
        pertanyaan: "Penugasan jadinya gimana?",
        jawaban:
            "Aduahh.. semangat kalii ngerjain penugasan. sementara penugasan di tunda dulu yaa.. biar kalian bisa fokus sama rangkaian acara PKKMB.",
    },
];

export default faqData;

/*





*/
